import { BarChart } from "@msuite/ui/charts";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { ClassNameProps } from "@msuite/ui/types";
import { formatNumber } from "@msuite/utils/numbers";
import type { IncomingInvoiceStatistics } from "@msuite/utils/types";

/** Props Interface */
interface IncomingInvoicesDueTileProps extends ClassNameProps {
	duePerWeek: IncomingInvoiceStatistics["duePerWeek"];
}

export function IncomingInvoicesDueTile({ className, duePerWeek }: IncomingInvoicesDueTileProps) {
	/** Context */
	const { t } = useTranslation();

	/** Computed */
	const data = duePerWeek.map(({ week, grossAmount }) => ({
		name: t("incoming_invoices.calendar_week", { week: `${week}` }),
		grossAmount,
	}));

	/** Render */
	return (
		<ContentCard
			title={t("incoming_invoices.due_per_week")}
			icon={icon("CalendarClock")}
			isCollapsible={false}
			className={className}
			contentClassName="h-72"
		>
			<BarChart
				data={data}
				dataKeys={["grossAmount"]}
				displayKeyMap={{ grossAmount: t("incoming_invoices.gross_amount") }}
				formatter={(value) => formatNumber(value, "currency")}
			/>
		</ContentCard>
	);
}
